module.exports = __webpack_public_path__ + "img/ativos.4edc5777.svg";